import { Reveal } from "../components/Reveal";
import ToolsMarquee from "../components/ToolsMarquee";

export default function ToolsSection() {
  return (
    <section className="border-y border-black/5 bg-[#fafafa] py-16 md:py-24 overflow-hidden" data-testid="tools-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-10 md:mb-14">
        <Reveal>
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98] max-w-3xl">
            We work in your stack — and beyond.
          </h2>
          <p className="mt-6 text-lg md:text-xl text-neutral-500 leading-relaxed max-w-2xl">
            Your operator plugs into the tools you already run and the ones worth adding: real estate CRMs, transaction platforms, marketing, automation and AI. No rip and replace, just a stack that finally works for you. A few we operate in daily:
          </p>
        </Reveal>
      </div>
      <ToolsMarquee />
    </section>
  );
}
